import React from "react";
import { motion } from "framer-motion";

// Pantalla de carga con el logo de Olimpo (casco) + efecto: glow que respira,
// anillo dorado girando y un leve latido del casco. Reemplaza al spinner genérico.
export default function LoaderOlimpo({ size = 60, texto, fullscreen = false }) {
  const wrap = fullscreen
    ? "min-h-screen bg-negro flex flex-col items-center justify-center gap-6"
    : "h-full w-full flex flex-col items-center justify-center gap-6";
  const ring = size * 1.85;
  const glow = size * 2.2;

  return (
    <div className={wrap} data-testid="loader-olimpo">
      <div className="relative flex items-center justify-center" style={{ width: glow, height: glow }}>
        <motion.div
          className="absolute rounded-full"
          style={{ width: glow, height: glow, background: "radial-gradient(circle, rgba(201,168,76,0.32) 0%, rgba(201,168,76,0) 68%)" }}
          animate={{ scale: [1, 1.22, 1], opacity: [0.45, 0.9, 0.45] }}
          transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          className="absolute rounded-full"
          style={{
            width: ring, height: ring,
            background: "conic-gradient(from 0deg, rgba(201,168,76,0) 0%, rgba(255,217,76,0.95) 22%, rgba(201,168,76,0) 52%)",
            WebkitMask: "radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px))",
            mask: "radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px))",
          }}
          animate={{ rotate: 360 }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
        />
        <motion.img
          src="/olimpo-helmet.png"
          alt="Olimpo"
          style={{ height: size, width: "auto", filter: "drop-shadow(0 0 14px rgba(201,168,76,0.55))" }}
          animate={{ scale: [1, 1.07, 1] }}
          transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
      {texto && <div className="mono-label text-gris" data-testid="loader-olimpo-texto">{texto}</div>}
    </div>
  );
}
